export default {
  exportDataTip: 'エクスポートするデータを選択してください',
  saledFeedback: 'アフターサービスフィードバック',
  cancelPay: 'キャンセル',
  cancelReason: 'キャンセル理由',
  merchantRemark: '代行備考',
  fanhui: '戻る',
  orderNo: 'オーダー番号',
  unreply: '返信なし',
  replied: '返信済み',
  apply: '申請',
  badImg: '不良画像',
  applyDetail: '申請の詳細',
  replyDate: '返信日',
  replyContent: '返信内容',
  orderMsg: '注文メッセージ',
  otherMsg: 'その他のメッセージ',
  clickUpload: 'アップロード',
  uploadRefreshTip: '全ての画像がアップロードされるのを待つかページを再読み込みし再度アップロードをお試し下さい',
  uploadNumberTip: '最大4枚の画像をアップロードできます',
  uploadNumberTip9: '最大9枚の画像をアップロードできます',
  // 导出的模版
  addTemplate01: '御 見 積 書',
  addTemplate02: '御中',
  addTemplate03: '件名',
  addTemplate04: 'ダウンロード',
  addTemplate05: '見積日',
  addTemplate06: '見積No',
  addTemplate07: '【発行元】',
  addTemplate08: '〒',
  addTemplate09: '担当',
  addTemplate10: '御見積総額（請求金額）',
  addTemplate11: '内訳',
  addTemplate12: '明細',
  addTemplate13: '商品画像',
  addTemplate14: '商品名',
  addTemplate15: 'サイズ',
  addTemplate16: '【備考・注意事項】',
  addTemplate17: '御見積書_',
  addTemplate18: '総額',
  addTemplate19: '支払い状況',
  addTemplate20: '支払い済み',
  addTemplate21: 'キャンセル済み',
  addTemplate22: '支払いを確定しますか？',
  addTemplate23: 'キャンセルしてもよろしいですか？',
  addTemplate24: '未処理',
  addTemplate25: '参考まで',
  addTemplate26: '支払い審査待ち',
  addTemplate27: '最低チャージ金額は～です',
  addTemplate28: '輸入代行・仕入れ代行業務における、商品代金、中国国内送料、代行手数料、検品代金を含めた明細書となります。',
  remarkTemplate26: '上記金額は、1元＝{rate}円（レート）にて換算しております。',
  remarkTemplate27: '国際送料・関税は本見積には含まれておらず、商品到着後に実費精算となります。',
  remarkTemplate28: '手数料は（商品代金＋中国国内送料）× {rate}% にて算出しております。',
  itemCost: '商品代金',
	domesticFreight: '中国国内送料',
	formulaStart: '手数料は（',
	formulaMiddle: '）× {rate}%',
	formulaFixed: ' + {fee}元',
	formulaEnd: ' にて算出しております。',
	priceRange: '{start}~{end}（元）',
	priceRangeEndless: '価格 > {start}（元） ',
	addTemplate29: '有効期限：本見積発行より1週間',
};
